import { payload } from "../../../../../node_modules/.pnpm/@sveltejs+kit@3.1.0_@sveltejs+vite-plugin-svelte@7.3.1_svelte@5.57.2_@typescript-eslint_7f2350defdee194b845c3d62252723ac/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_CORS_PROXY_URL = "https://proxy.gitstrata.com";
export const PUBLIC_SHARED_CACHE_URL = "https://proxy.gitstrata.com";
export const PUBLIC_ANALYTICS_ID = "9c082669-20f5-486f-85b8-13911ded8e14";
